/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询是否有待支付订单并返回数量
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<order.PendingOrderDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/pending-order`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
